export * from './points-transfer.page'
